/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createEffectiveBasicCost } from '../fn/effective-basic-cost/create-effective-basic-cost';
import { CreateEffectiveBasicCost$Params } from '../fn/effective-basic-cost/create-effective-basic-cost';
import { deleteEffectiveBasicCost } from '../fn/effective-basic-cost/delete-effective-basic-cost';
import { DeleteEffectiveBasicCost$Params } from '../fn/effective-basic-cost/delete-effective-basic-cost';
import { EffectiveBasicCostDto } from '../models/effective-basic-cost-dto';
import { EffectiveBasicCostDtoPage } from '../models/effective-basic-cost-dto-page';
import { getEffectiveBasicCost } from '../fn/effective-basic-cost/get-effective-basic-cost';
import { GetEffectiveBasicCost$Params } from '../fn/effective-basic-cost/get-effective-basic-cost';
import { listEffectiveBasicCosts } from '../fn/effective-basic-cost/list-effective-basic-costs';
import { ListEffectiveBasicCosts$Params } from '../fn/effective-basic-cost/list-effective-basic-costs';
import { updateEffectiveBasicCost } from '../fn/effective-basic-cost/update-effective-basic-cost';
import { UpdateEffectiveBasicCost$Params } from '../fn/effective-basic-cost/update-effective-basic-cost';

@Injectable({ providedIn: 'root' })
export class EffectiveBasicCostApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `listEffectiveBasicCosts()` */
  static readonly ListEffectiveBasicCostsPath = '/v0/effectiveBasicCost';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listEffectiveBasicCosts()` instead.
   *
   * This method doesn't expect any request body.
   */
  listEffectiveBasicCosts$Response(params?: ListEffectiveBasicCosts$Params, context?: HttpContext): Observable<StrictHttpResponse<EffectiveBasicCostDtoPage>> {
    return listEffectiveBasicCosts(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listEffectiveBasicCosts$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listEffectiveBasicCosts(params?: ListEffectiveBasicCosts$Params, context?: HttpContext): Observable<EffectiveBasicCostDtoPage> {
    return this.listEffectiveBasicCosts$Response(params, context).pipe(
      map((r: StrictHttpResponse<EffectiveBasicCostDtoPage>): EffectiveBasicCostDtoPage => r.body)
    );
  }

  /** Path part for operation `createEffectiveBasicCost()` */
  static readonly CreateEffectiveBasicCostPath = '/v0/effectiveBasicCost';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createEffectiveBasicCost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createEffectiveBasicCost$Response(params: CreateEffectiveBasicCost$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return createEffectiveBasicCost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createEffectiveBasicCost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createEffectiveBasicCost(params: CreateEffectiveBasicCost$Params, context?: HttpContext): Observable<string> {
    return this.createEffectiveBasicCost$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `getEffectiveBasicCost()` */
  static readonly GetEffectiveBasicCostPath = '/v0/effectiveBasicCost/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEffectiveBasicCost()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEffectiveBasicCost$Response(params: GetEffectiveBasicCost$Params, context?: HttpContext): Observable<StrictHttpResponse<EffectiveBasicCostDto>> {
    return getEffectiveBasicCost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getEffectiveBasicCost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEffectiveBasicCost(params: GetEffectiveBasicCost$Params, context?: HttpContext): Observable<EffectiveBasicCostDto> {
    return this.getEffectiveBasicCost$Response(params, context).pipe(
      map((r: StrictHttpResponse<EffectiveBasicCostDto>): EffectiveBasicCostDto => r.body)
    );
  }

  /** Path part for operation `updateEffectiveBasicCost()` */
  static readonly UpdateEffectiveBasicCostPath = '/v0/effectiveBasicCost/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateEffectiveBasicCost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateEffectiveBasicCost$Response(params: UpdateEffectiveBasicCost$Params, context?: HttpContext): Observable<StrictHttpResponse<EffectiveBasicCostDto>> {
    return updateEffectiveBasicCost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateEffectiveBasicCost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateEffectiveBasicCost(params: UpdateEffectiveBasicCost$Params, context?: HttpContext): Observable<EffectiveBasicCostDto> {
    return this.updateEffectiveBasicCost$Response(params, context).pipe(
      map((r: StrictHttpResponse<EffectiveBasicCostDto>): EffectiveBasicCostDto => r.body)
    );
  }

  /** Path part for operation `deleteEffectiveBasicCost()` */
  static readonly DeleteEffectiveBasicCostPath = '/v0/effectiveBasicCost/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteEffectiveBasicCost()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteEffectiveBasicCost$Response(params: DeleteEffectiveBasicCost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteEffectiveBasicCost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteEffectiveBasicCost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteEffectiveBasicCost(params: DeleteEffectiveBasicCost$Params, context?: HttpContext): Observable<void> {
    return this.deleteEffectiveBasicCost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
